module.exports = __webpack_public_path__ + "img/afdc433.jpg";